import { Component } from "react";

// Keeps one failing section (a chart, a table) from blanking the whole page.
class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { error: null };
		this.handleRetry = this.handleRetry.bind(this);
	}

	static getDerivedStateFromError(error) {
		return { error };
	}

	componentDidCatch(error, info) {
		console.error("Section failed to render", error, info);
	}

	handleRetry() {
		this.setState({ error: null });
	}

	render() {
		if (!this.state.error) {
			return this.props.children;
		}

		return (
			<section className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
				<h2 className="text-base font-semibold text-slate-900">
					{this.props.title || "This section could not be displayed"}
				</h2>
				<p className="mt-1 text-sm text-slate-500">
					Something went wrong rendering it. The rest of the page is unaffected.
				</p>
				<button
					type="button"
					onClick={this.handleRetry}
					className="mt-4 inline-flex h-9 items-center rounded-md border border-slate-200 bg-white px-3 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400"
				>
					Try again
				</button>
			</section>
		);
	}
}

export default ErrorBoundary;
